<template>
  <ul class="vertical-nav">
    <li class="rootMenu"><a>会员中心</a></li>
    <li v-for="(menu, index) in menuList" :key="index">
        <router-link v-if="menu.link" :to="menu.link" :class="{ active: menu.currentMenuLink == currentRoutePath}">{{ menu.name }}</router-link>
        <router-link v-if="!menu.link" :to="menu.link" :class="{ active: menu.name == parentMenuName}">{{ menu.name }}</router-link>
        <ul v-if="menu.children.length !=0">
            <li class="subMenu" v-for="(subMenu, subIndex) in menu.children" :key="`${index}-${subIndex}`">
                <router-link :to="subMenu.link" :class="{ active: subMenu.currentMenuLink.indexOf(currentRoutePath) != -1}">{{ subMenu.name }}</router-link>
            </li>
        </ul>
    </li>
</ul>
</template>

<script>
import menu from '@/assets/config/personCenterMenu.js';
import menuCompany from '@/assets/config/personCenterMenuCompany.js';
export default {
    data() {
        return {
            menuList: [],
            currentRoutePath: '',
            parentMenuName: '',
        }
    },
    computed: {
        accountType() {
            return this.$store.state.permission.accountType;
        }
    },
    created() {
        this.menuList = this.accountType == 2 ? [...menuCompany] : [...menu];
    },
    methods: {
        selectParentMenuName(path) {
           this.menuList.forEach(menu => {
                if (menu.currentMenuLink == path) {
                    this.parentMenuName = '';
                    return;
                }
                menu.children.forEach(subMenu => {
                    if (subMenu.currentMenuLink.indexOf(path) !== -1) {
                        this.parentMenuName = menu.name;
                        return;
                    }
                })
                
           })
        }
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                // console.log(to.path)
                this.currentRoutePath = to.path;
                this.selectParentMenuName(this.currentRoutePath);
                console.log(this.parentMenuName)
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        }
    }
}
</script>

<style>
.vertical-nav li a.active {
    border-left: none;
}
.textBtn {
    color: #2e8cd8;
}
</style>